import PropTypes from 'prop-types';
import React from 'react';

import Club from './Club';

export default class SkirmishClubs extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };
  state = {
    active: '',
  };
  toggleClub = (e) => {
    const {id} = e.currentTarget;
    if (this.state.active !== id) {
      this.setState({active: id});
    }
    if (this.state.active === id) {
      this.setState({active: ''});
    }
  };
  render() {
    const {title, clubs} = this.props.data;
    const clubArray = clubs || [];
    const clubTeams = clubArray.map((item, index) => {
      const {key} = item;
      const id = `club-${index}`;
      const active = this.state.active === id;
      return (
        <Club
          toggleSection={this.toggleClub}
          id={id}
          data={item}
          active={active}
          key={`club-${key}`}
        />
      );
    });
    return (
      <section className="skirmish-clubs">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <h1>{title}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">{clubTeams}</div>
          </div>
        </div>
      </section>
    );
  }
}
